
const SET_ROOMS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rooms.data = payload
    state.rooms.last_update = new Date()
  }
};

const SET_LOADING_ROOMS = (state, payload) => {
  state.loading_rooms = payload
}

/**
 * Receber token_sala
 */
const ADD_ROOM_COUNT_UNREAD = (state, payload) => {
  if (state.rooms_on_view.includes(payload)) {
    return
  }
  const sala = state.rooms.data.find((s) => {
    return s.token_sala === payload
  })

  if (sala) {
    sala.unread_quantity += 1
  }
}

const SET_READ_ROOM = (state, payload) => {
  const sala = state.rooms.data.find((s) => {
    return s.token_sala === payload
  })

  if (sala) {
    sala.unread_quantity = 0
  }
}

const SELECT_ROOM = (state, payload) => {
  if (payload) {
    state.rooms_on_view = [...new Set([...state.rooms_on_view, payload])]
  }
}

const UNSELECT_ROOM = (state, payload) => {
  if (payload) {
    state.rooms_on_view = state.rooms_on_view.filter((s) => {
      return s === payload
    })
  }
}

export {
  SET_ROOMS,
  SET_LOADING_ROOMS,
  ADD_ROOM_COUNT_UNREAD,
  SET_READ_ROOM,
  SELECT_ROOM,
  UNSELECT_ROOM,
}
